export const PAGINATION_ARG_DEFAULTS = {
  limit: 25,
  offset: 0,
};
